import { gql } from '@apollo/client';

const CREATE_STUDY_MUTATION = gql`
  mutation createStudy($input: StudyInfoInput) {
    createStudy(input: $input) {
      isSuccess
      message
      study {
        id
        isTest
        facility {
          id
          status
        }
        isDeviceAssignmentPending
        device {
          id
          deviceId
          model
        }
      }
    }
  }
`;

export default CREATE_STUDY_MUTATION;
